'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.listenForAddedElements = listenForAddedElements;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef {Object} listenForAddedElements~options
 * @property {string} selector - The selector to listen for.
 * @property {Node} listenOnElement - The parent element for listening. Defaults to the current `<body>`.
 * @property {bool} checkForExistingNodes - If set to `true` then all existing nodes will also be processed.
 */

/**
 * @callback listenForAddedElements~callback
 * @param {Node} addedNode - The node that has been added to the DOM.
 * @returns {void}
 */

/**
 * @description Calls the given callback every time an element with the given selector is being inserted into the DOM.
 * @summary
 * This method will setup a MutationObserver that listens for DOM insertions of elements with the
 * given selector. The given callback will be called once for every inserted DOM Node.
 *
 * This can be used in order to initialize functionality for elements that are inserted after
 * the page has been loaded (e.g. AJAX results).
 *
 * If `checkForExistingNodes` is supplied then this method will also check for elements that exist
 * at call time and calls the callback for existing elements.
 *
 * @example
 * listenForAddedElements(
 *      { selector: '[data-target-enhancement]', checkForExistingNodes: true },
 *      element => targetEnhance(element)
 * );
 *
 * @param {listenForAddedElements~options} options
 * @param {listenForAddedElements~callback} callback - The callback that is being called for every element that matches
 *                                           the given selector.
 * @returns {MutationObserver}
 */
function listenForAddedElements(_ref, callback) {
    var selector = _ref.selector,
        _ref$listenOnElement = _ref.listenOnElement,
        listenOnElement = _ref$listenOnElement === undefined ? document.body : _ref$listenOnElement,
        _ref$checkForExisting = _ref.checkForExistingNodes,
        checkForExistingNodes = _ref$checkForExisting === undefined ? false : _ref$checkForExisting;

    if (checkForExistingNodes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(listenOnElement.querySelectorAll(selector)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var element = _step.value;

                callback(element);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    var observer = new MutationObserver(function (mutations) {
        var addedNodes = mutations.reduce(function (all, current) {
            return [].concat((0, _toConsumableArray3.default)(all), (0, _toConsumableArray3.default)(current.addedNodes));
        }, []);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = (0, _getIterator3.default)(addedNodes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var added = _step2.value;


                // Skip non-tag elements (comments & text)
                if (!added.tagName) {
                    continue;
                }

                // Check for direct matches
                if (matchesSelector(added, selector)) {
                    callback(added);
                }

                // Check for deep matches
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(added.querySelectorAll(selector)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var _element = _step3.value;

                        callback(_element);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    });

    observer.observe(listenOnElement, { childList: true, subtree: true });

    return observer;
}

/** @private */
function matchesSelector(element, selector) {
    var methods = ['matches', 'matchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector', 'webkitMatchesSelector'];

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = (0, _getIterator3.default)(methods), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var method = _step4.value;

            if (element[method]) {
                return element[method](selector);
            }
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    throw new Error('None of the following methods are available in the current browser: ' + methods.join(','));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/dom-utility/src/listen-for-added-elements.js
// module id = 107
// module chunks = 0 2